import { Component, OnDestroy } from '@angular/core';

import { Store } from '@src/store';
import { userActions } from '@src/store/reducers/userReducer';

@Component({
    selector: 'side-menu',
    template: require('./side-menu.component.html'),
    styles: [require('./side-menu.component.scss')]
})
export class SideMenuComponent implements OnDestroy {
    public userModules: any[];
    public expand = false;

    private unsubscribe: any;

    constructor(store: Store) {
        const menuItems = {
            Insights: 'app.authorized.dashboard',
            Dashboard: 'app.authorized.dashboard',
            Projects: 'app.authorized.projects',
            Statistics: 'app.authorized.dashboard',
            Help: 'app.authorized.about',
            Online: 'app.authorized.online'
        };
        this.unsubscribe = store.subscribe(() => {
            this.userModules = store.getState().user.userModules;
            if (this.userModules != null) {
                this.userModules.forEach((item: any) => {
                    item.appLink = menuItems[item.name];
                });

                // Filter out Dashboard if showDashboard is false
                if (!(window as any).__env?.config?.showDashboard) {
                    this.userModules = this.userModules.filter(
                        (item: any) => item.name !== 'Dashboard'
                    );
                }
            }
        });
        store.dispatch({ type: userActions.GET_MODULES });
    }

    public ngOnDestroy() {
        this.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/side-menu/side-menu.component.ts